var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100px",
  height: "100px",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "providers/google-classroom/icon")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.0183036%",
  y1: "1.328327%",
  x2: "50.0183036%",
  y2: "101.044677%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF360C",
  stopOpacity: 0.2,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF360C",
  stopOpacity: 0.02,
  offset: "100%"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: "3.44460799%",
  cy: "2.34388%",
  fx: "3.44460799%",
  fy: "2.34388%",
  r: "138.968014%",
  gradientTransform: "translate(0.034446,0.023439),scale(0.859375,1.000000),translate(-0.034446,-0.023439)",
  id: "radialGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0.1,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "providers/google-classroom/icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7F7F9",
  x: 0,
  y: 0,
  width: 100,
  height: 100
}), /*#__PURE__*/React.createElement("g", {
  id: "Google_Classroom_Logo",
  transform: "translate(18.000000, 23.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#0F9D58",
  points: "5.81416235 5.786 58.1747841 5.786 58.1747841 49.203 5.81416235 49.203"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.6283247,28.952 C45.4411054,28.952 46.9001727,27.489 46.9001727,25.696 C46.9001727,23.903 45.4300518,22.44 43.6283247,22.44 C41.8265976,22.44 40.3564767,23.903 40.3564767,25.696 C40.3564767,27.489 41.8265976,28.952 43.6283247,28.952 L43.6283247,28.952 Z M43.6283247,31.119 C40.1243523,31.119 36.355095,32.967 36.355095,35.255 L36.355095,37.631 L50.9015544,37.631 L50.9015544,35.255 C50.9015544,32.967 47.1322971,31.119 43.6283247,31.119 Z M20.3606218,28.952 C22.1734024,28.952 23.6324698,27.489 23.6324698,25.696 C23.6324698,23.903 22.1623489,22.44 20.3606218,22.44 C18.5588946,22.44 17.0887737,23.903 17.0887737,25.696 C17.0887737,27.489 18.5588946,28.952 20.3606218,28.952 L20.3606218,28.952 Z M20.3606218,31.119 C16.8566494,31.119 13.0873921,32.967 13.0873921,35.255 L13.0873921,37.631 L27.6338515,37.631 L27.6338515,35.255 C27.6338515,32.967 23.8645941,31.119 20.3606218,31.119 Z",
  id: "Shape",
  fill: "#57BB8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32,26.048 C34.4096718,26.048 36.3661485,24.101 36.3551416,21.703 C36.3551416,19.305 34.3986183,17.358 31.9889465,17.3689536 C29.5792746,17.3689536 27.6338515,19.316 27.6338515,21.714 C27.6338515,24.112 29.5903282,26.048 32,26.048 Z M32,28.952 C27.092228,28.952 21.8196891,31.548 21.8196891,34.738 L21.8196891,37.631 L42.1803109,37.631 L42.1803109,34.738 C42.1803109,31.537 36.907772,28.952 32,28.952 Z",
  id: "Shape",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#F1F1F1",
  points: "37.8141623 46.321 50.9015544 46.321 50.9015544 49.214 37.8141623 49.214"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6338515,0 L4.36614853,0 C1.95647668,0 0,1.947 0,4.345 L0,50.666 C0,53.053 1.95647668,55 4.36614853,55 L59.6338515,55 C62.0435233,55 64,53.053 64,50.655 L64,4.345 C63.9889465,1.947 62.0435233,0 59.6338515,0 Z M58.1747841,49.214 L5.81416235,49.214 L5.81416235,5.786 L58.1747841,5.786 L58.1747841,49.214 Z",
  id: "Shape",
  fill: "#F4B400"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6338515,0 L4.36614853,0 C1.95647668,0 0,1.947 0,4.345 L0,4.708 C0,2.31 1.95647668,0.363 4.36614853,0.363 L59.6338515,0.363 C62.0435233,0.363 64,2.31 64,4.708 L64,4.345 C63.9889465,1.947 62.0435233,0 59.6338515,0 Z",
  id: "Path",
  fill: "#FFFFFF",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6338515,54.637 L4.36614853,54.637 C1.95647668,54.637 0,52.69 0,50.292 L0,50.655 C0,53.053 1.95647668,55 4.36614853,55 L59.6338515,55 C62.0435233,55 64,53.053 64,50.655 L64,50.292 C63.9889465,52.69 62.0435233,54.637 59.6338515,54.637 Z",
  id: "Path",
  fill: "#BF360C",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-1)",
  points: "50.8794473 49.214 37.7920553 49.214 43.6062176 55 56.6825561 55"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#263238",
  opacity: 0.2,
  points: "5.81416235 5.423 58.1747841 5.423 58.1747841 5.786 5.81416235 5.786"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  opacity: 0.2,
  points: "5.81416235 49.214 58.1747841 49.214 58.1747841 49.577 5.81416235 49.577"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6338515,0 L4.36614853,0 C1.95647668,0 0,1.947 0,4.345 L0,50.666 C0,53.053 1.95647668,55 4.36614853,55 L59.6338515,55 C62.0435233,55 64,53.053 64,50.655 L64,4.345 C63.9889465,1.947 62.0435233,0 59.6338515,0 Z",
  id: "Path",
  fill: "url(#radialGradient-2)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.73d99736d77079a93fb87058dd83a9d2.svg";